const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";
export const types = {
  GET_PREPAY_PROVISIONAL_AGREEMENT_BEGIN:
    'GET_PREPAY_PROVISIONAL_AGREEMENT_BEGIN',
  GET_PREPAY_PROVISIONAL_AGREEMENT_SUCCESS:
    'GET_PREPAY_PROVISIONAL_AGREEMENT_SUCCESS',
  GET_PREPAY_PROVISIONAL_AGREEMENT_FAILURE:
    'GET_PREPAY_PROVISIONAL_AGREEMENT_FAILURE',
    
  GET_SELLING_TYPES_BEGIN: 'GET_SELLING_TYPES_BEGIN',
  GET_SELLING_TYPES_SUCCESS: 'GET_SELLING_TYPES_SUCCESS',
  GET_SELLING_TYPES_FAILURE: 'GET_SELLING_TYPES_FAILURE',
};
export const actions = {
  getPrepayProvisionalAgreement: (product, idType) => ({
    type: types.GET_PREPAY_PROVISIONAL_AGREEMENT_BEGIN,
    product,
    idType,
  }),
  successGetPrepayProvisionalAgreement: (data) => ({
    type: types.GET_PREPAY_PROVISIONAL_AGREEMENT_SUCCESS,
    payload: data,
  }),
  failureGetPrepayProvisionalAgreement: (error) => ({
    type: types.GET_PREPAY_PROVISIONAL_AGREEMENT_FAILURE,
    payload: error,
  }),
  getSellingTypes: () => ({ type: types.GET_SELLING_TYPES_BEGIN }),
  successGetSellingTypes: data => ({ type: types.GET_SELLING_TYPES_SUCCESS, payload: data }),
  failureGetSellingTypes: error => ({ type: types.GET_SELLING_TYPES_FAILURE, payload: error }),
};
const initialState = {
  prepayProvisionalAgreement: null,
  prepayProvisionalAgreementFetching: false,
  prepayProvisionalAgreementError: false,

  sellingTypes: null,
  sellingTypesFetching: false,
  sellingTypesError: false,
};
function reducer(state = { ...initialState }, { type, payload }) {
  switch (type) {
    case HYDRATE: {
      const { cq } = payload;
      return {
        ...state,
        ...cq,
      };
    }
    case types.GET_PREPAY_PROVISIONAL_AGREEMENT_BEGIN: {
      return {
        ...state,
        prepayProvisionalAgreement: null,
        prepayProvisionalAgreementFetching: true,
        prepayProvisionalAgreementError: false,
      };
    }
    case types.GET_PREPAY_PROVISIONAL_AGREEMENT_SUCCESS: {
      return {
        ...state,
        prepayProvisionalAgreement: payload,
        prepayProvisionalAgreementFetching: false,
        prepayProvisionalAgreementError: false,
      };
    }
    case types.GET_PREPAY_PROVISIONAL_AGREEMENT_FAILURE: {
      return {
        ...state,
        prepayProvisionalAgreement: null,
        prepayProvisionalAgreementFetching: false,
        prepayProvisionalAgreementError: true,
      };
    }
    case types.GET_SELLING_TYPES_BEGIN: {
      return {
        ...state,
        sellingTypesFetching: true,
        sellingTypesError: false,
      };
    }
    case types.GET_SELLING_TYPES_SUCCESS: {
      return {
        ...state,
        sellingTypes: payload,
        sellingTypesFetching: false,
        sellingTypesError: false,
      }
    }
    case types.GET_SELLING_TYPES_FAILURE: {
      return {
        ...state,
        sellingTypes: null,
        sellingTypesFetching: false,
        sellingTypesError: true,
      };
    }
    default:
      return {
        ...state,
      };
  }
}
export default reducer;
